module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("10")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Saturday Afternoon")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Detective Sergeant Cabrini Paiz slipped her smartphone into her pocket. She frowned as she stepped back inside the conference room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s up?” Lieutenant Bob Swanson stood beside the whiteboard, dry-erase marker in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini shook her head. “Wasn’t who I expected. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several other APD detectives sat around the table, and Cabrini rejoined them. “What did I miss?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swannie shook his head. “Nothing, really. We were trying to brainstorm other ways to determine the identity of our homicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Detective Kramer spoke up. “When will we get a report from OMI?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini said, “They won’t have anything until later this afternoon. I had hoped that call would be them. They said earlier they’re swamped and short-staffed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kramer blew out a breath. “They should pay those people more. You couldn’t get me to do that job for all the tea in China.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another detective, brand new to the division, grinned and spoke up. “I heard they were using a lot of interns from the medical school, and there’s a whole lot of pukin’ goin’ on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Swannie said. “Let’s can the humor. We have a dead guy we can’t identify, and we’re short on time, so think, people. Think!” His irritation silenced the jokester, who turned pink and studied his tablet with deep concentration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini spoke up. “We need to reach out to some of our informants.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They tossed that idea around for a few minutes, and each detective made a list of likely sources of information for follow-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We should reach out to the FBI,” Swannie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several groans went up around the table. He held up both hands to silence the complaints.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come on,” he said. “I didn’t say we’re turning it over. I’m just saying it’s imperative we ID this fellow before the news leaks out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini sighed. “I’m afraid we’ve missed that boat, Sir.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Now it was Swannie’s turn to frown. “Do I really want to know ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("what you mean by that?”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini grinned. “Oh, probably not. But one way or the other, you’ll be hearing more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swannie sat back in his chair, gazing up at the ceiling. “Okay. Who squealed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently the young ranger who discovered the body,” Cabrini said, but didn’t meet Swannie’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took a breath. “I don’t know all the details, but apparently he encountered Harrie and Ginger this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swannie sprang from his chair and paced the floor, a string of fiery, colorful language erupting from his lips. When he’d finished and regained his composure, he smiled. But to Cabrini, it was a scary smile, and she waited for the words she dreaded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I. Don’t. Care. HOW you do it,” Swannie said, through gritted teeth. “But I want you to make sure our little redheaded dynamo does NOT involve herself in this investigation. And she’d better keep her mouth shut about it. You got that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini nodded, but who was she kidding? This would not end well. “Of course, Lieutenant. Your wish is my command.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swannie’s shoulders slumped, and he sat down, shaking his head. He scrubbed his face, as if to wipe away the consternation he obviously felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just do the best you can, okay? Maybe we can distract her with something else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, sure thing. That always works so well.” Cabrini stood and gathered up her folders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Keep me posted, will you?” Swannie reverted to downright pleading. “I have to walk a pretty tight rope here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini turned back to him and smiled as she prepared to walk out the door. She felt sorry for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, Lieutenant. I know.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a259fa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chapter10.vue
// module id = 99
// module chunks = 0